import { Elevator } from 'modules/domain/warehouses/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Card } from 'views/components/Card/Card'
import { KeyValue } from 'views/components/KeyValue/KeyValue'
import { labelTarif } from 'modules/utils/numbers/formatTarif'
import { DASH } from 'modules/constants'

const rubPerTon = (label: string) => `${label}, Р/т`
export const Costs: FC<{ elevator: Elevator }> = ({ elevator }) => {
  const costs = elevator.elevator_costs[0]
  const { t } = useTranslation('warehouses')
  if (!costs) return null
  const storageCostsUnit = costs.storage_costs_unit ? t(`storage_costs_units.${costs.storage_costs_unit}`) : null
  return (
    <Card.GapableContent>
      <Card.Title>{t('costs')}</Card.Title>
      <Card.Container bordered>
        <Card.GapableContent>
          {!costs.is_composite_costs && (
            <Card.Grid cols={2} columnGap={32}>
              <KeyValue label={rubPerTon(t('elevator_costs.acceptance_costs'))}>
                {costs.acceptance_costs ?? DASH}
              </KeyValue>
              <KeyValue label={t('elevator_costs.storage_costs')}>
                {costs.storage_costs ?? DASH}
                {storageCostsUnit ? ` (${storageCostsUnit})` : DASH}
              </KeyValue>
              <KeyValue label={rubPerTon(t('elevator_costs.mechanical_railcar_loading_costs'))}>
                {costs.mechanical_railcar_loading_costs ?? DASH}
              </KeyValue>
              <KeyValue label={rubPerTon(t('elevator_costs.expedite_costs'))}>{costs.expedite_costs ?? DASH}</KeyValue>
              <KeyValue label={rubPerTon(t('elevator_costs.documents_costs'))}>
                {costs.documents_costs ?? DASH}
              </KeyValue>
              <KeyValue label={rubPerTon(t('elevator_costs.other_costs'))}>{costs.other_costs ?? DASH}</KeyValue>
            </Card.Grid>
          )}
          {costs.is_composite_costs && (
            <KeyValue label={labelTarif(t('elevator_costs.composite_costs'))}>{costs.composite_costs ?? DASH}</KeyValue>
          )}
          {costs.comment && <KeyValue label={t('common:comment')}>{costs.comment ?? DASH}</KeyValue>}
        </Card.GapableContent>
      </Card.Container>
    </Card.GapableContent>
  )
}
